/* ============================================================
   ÉTAPE 2: CONFIGURATION DEMANDEUR (Refactorisée)
   ============================================================ */

import { SaveButton } from '../SaveButton';
import { DefaultFieldsInfo } from '../DefaultFieldsInfo';
import { CompanyConfig } from '../CompanyConfig';
import { BookingReasonConfig } from '../BookingReasonConfig';
import { FormPreview } from '../FormPreview';

interface Step2RequesterConfigProps {
  data: any;
  onChange: (updates: any) => void;
  onSave?: () => void;
  isSaving?: boolean;
}

export function Step2RequesterConfig({ data, onChange, onSave, isSaving }: Step2RequesterConfigProps) {
  const requireReason = !!data.requireBookingReason;
  const reasonLabel = data.bookingReasonLabel || 'Raison de la réservation';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
      <DefaultFieldsInfo />

      <CompanyConfig data={data} onChange={onChange} />

      <BookingReasonConfig data={data} onChange={onChange} />

      <FormPreview requireReason={requireReason} reasonLabel={reasonLabel} />

      {onSave && <SaveButton onSave={onSave} isSaving={isSaving || false} />}
    </div>
  );
}
